import * as React from "react";
import { ReactNode, useContext } from "react";
import { Route, Routes } from "react-router-dom";
import { Formik } from "formik";
import { isNil } from "ramda";

import { InnerFormContext } from "../../controls/innerFormContext";
import { ValueRecord } from "../../types";
import { ConfirmationWrapper } from "../confirmationView";

export const FormView: React.FC<{
  form: ReactNode;
  confirm?: ReactNode;
}> = ({ form, confirm }) => {
  const formContext = useContext(InnerFormContext);
  if (isNil(formContext)) return <></>;

  const { initialData, formData, validate, validationSchema, confirmData: handleSubmit } = formContext;
  const initialValues = formData ?? initialData ?? {};

  return (
    <Formik<ValueRecord | Record<string, never>>
      enableReinitialize
      initialValues={initialValues ?? {}}
      onSubmit={handleSubmit}
      validate={validate}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      <Routes>
        <Route index element={form} />
        {confirm ? <Route path="confirm" element={<ConfirmationWrapper>{confirm}</ConfirmationWrapper>} /> : null}
      </Routes>
    </Formik>
  );
};
